import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tab-console" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 0,
  class: "empty-data"
}
const _hoisted_4 = {
  key: 1,
  class: "empty-data"
}
const _hoisted_5 = {
  key: 2,
  class: "list"
}
const _hoisted_6 = { class: "avatar" }
const _hoisted_7 = ["src", "onClick"]
const _hoisted_8 = { class: "actions" }
const _hoisted_9 = ["onClick"]

import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import store from "@/store";

import { toast } from "@/common/utils/toast";

import {
  imageList,
  imageCreate,
  imageUpdate,
  imageDelete,
} from "@/common/api/rest/console/image";

import type { ConsoleImageType } from "@/common/types/console/image";

import {
  baseConfirm,
  baseModal,
  baseSidebar,
  baseLoading,
  cropImage,
  svgIcon,
  viewImage,
  viewImageList,
} from "@/common/components";

const imageSize = "15rem";


export default /*@__PURE__*/_defineComponent({
  __name: 'images',
  props: {
    consoleId: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "f7883742": (imageSize)
}))

const { t, locale } = useI18n();

const props = __props;

const images = ref<ConsoleImageType[]>([]);
const selectedImage = ref<ConsoleImageType | null>(null);
const selectedImageIndex = ref<number | null>(null);

const loading = ref(true);
const showImage = ref(false);
const showModalAddImage = ref(false);
const showModalDelImage = ref(false);

async function fetchImages() {
  await imageList(props.consoleId)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        images.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function imageShow(index: number) {
  selectedImageIndex.value = index;
  showImage.value = true;
}

function imageShowCancel() {
  selectedImageIndex.value = null;
  showImage.value = false;
}

function addImage() {
  showModalAddImage.value = true;
}

function addImageCancel() {
  showModalAddImage.value = false;
}

async function addImageConfirm(file: string) {
  showModalAddImage.value = false;

  store.commit("SET_LOADING", true);

  imageCreate(props.consoleId, {
    file,
    status: "ACTIVE",
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchImages();
        addImageCancel();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      showModalAddImage.value = true;
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function removeImage(item: ConsoleImageType) {
  selectedImage.value = item;
  showModalDelImage.value = true;
}

function removeImageCancel() {
  selectedImage.value = null;
  showModalDelImage.value = false;
}

async function removeImageConfirm() {
  showModalDelImage.value = false;

  store.commit("SET_LOADING", true);

  await imageDelete(selectedImage.value.image_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchImages();
        removeImageCancel();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

onMounted(async () => {
  await fetchImages();
  loading.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(baseLoading))
          ]))
        : (images.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(svgIcon), {
                icon: "no-image",
                size: "3rem"
              }),
              _createElementVNode("span", null, _toDisplayString(_unref(t)("collection.texts.no_images")), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.image_id,
                  class: "image"
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("img", {
                      src: item.small,
                      onClick: ($event: any) => (imageShow(index))
                    }, null, 8, _hoisted_7)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("button", {
                      class: "btn btn-transparent w-9 h-9 p-0",
                      onClick: ($event: any) => (removeImage(item))
                    }, [
                      _createVNode(_unref(svgIcon), {
                        icon: "trash",
                        size: "1.5rem"
                      })
                    ], 8, _hoisted_9)
                  ])
                ]))
              }), 128))
            ])),
      _createElementVNode("button", {
        class: "btn btn-md btn-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (addImage()))
      }, [
        _createVNode(_unref(svgIcon), {
          icon: "add",
          size: "1.25rem"
        }),
        _createElementVNode("span", null, _toDisplayString(_unref(t)("collection.labels.image")?.toUpperCase()), 1)
      ])
    ]),
    (showImage.value)
      ? (_openBlock(), _createBlock(_unref(viewImageList), {
          key: 0,
          images: images.value.map((item) => item.large),
          selected: selectedImageIndex.value,
          onClose: imageShowCancel
        }, null, 8, ["images", "selected"]))
      : _createCommentVNode("", true),
    (showModalAddImage.value)
      ? (_openBlock(), _createBlock(_unref(cropImage), {
          key: 1,
          onChange: _cache[1] || (_cache[1] = ($event: any) => (addImageConfirm($event))),
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (addImageCancel()))
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(baseConfirm), {
      show: showModalDelImage.value,
      title: _unref(t)('collection.modals.titles.del_image').toUpperCase(),
      message: 
        _unref(t)('collection.modals.messages.del_image', {
          name: selectedImage.value?.title?.toUpperCase(),
        })
      ,
      onCancel: _cache[3] || (_cache[3] = ($event: any) => (removeImageCancel())),
      onConfirm: _cache[4] || (_cache[4] = ($event: any) => (removeImageConfirm()))
    }, null, 8, ["show", "title", "message"])
  ]))
}
}

})